import Slide from '@mui/material/Slide';

const baseSnackbarOptions = {
  maxSnack: 5,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  preventDuplicate: true,
  TransitionComponent: Slide,
  hideIconVariant: true,
};

export const getSnackbarOptions = () => baseSnackbarOptions;
